import { Trans, useTranslation } from "react-i18next";
import React, { useState } from "react";
import useRoutes, { useHistory } from "../hooks/useRoutes";
import { Field, Form, Formik } from "formik";
import { callAPI, useAPI } from "../../lib/common";
import FormikPasswordField from "../../components/Common/FormikPasswordField";
import { FormHelperText } from "@material-ui/core";
import BoxActions from "./FrontPage/BoxActions";
import LoadingButton from "../../components/LoadingButton";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  heading: {
    color: theme.palette.secondary.main + " !important", // Because of desktop
    textTransform: "uppercase",
    marginBottom: theme.spacing(4),
    fontSize: "30px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "15px",
    },
  },
  contentText: {
    fontSize: "20px",
    marginBottom: 0,
    [theme.breakpoints.down("xs")]: {
      fontSize: "15px",
    },
  },
  form: {
    textAlign: "center",
    "& h4": {
      marginBottom: theme.spacing(4),
    },
    "& .MuiFormControl-root": {
      marginBottom: theme.spacing(4),
    },
    marginBottom: 0,
  },
}));

const ResetPassword = ({ code }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [serverError, setServerError] = useState("");
  const routes = useRoutes();
  const history = useHistory();

  const [data, isLoading] = useAPI(`/api/webshop/reset-password/` + code);

  if (isLoading) {
    return (
      <div>
        <Trans>Validating reset request</Trans>
      </div>
    );
  }

  if (!data.valid) {
    return (
      <div>
        <Trans>Sorry, no account connected to this key</Trans>
      </div>
    );
  }

  return (
    <div>
      <Formik
        initialValues={{
          password: "",
          retypepassword: "",
        }}
        validate={(values) => {
          if (values.password.length <= 6) {
            return {
              password: t("That's too short!"),
            };
          }
          if (values.password !== values.retypepassword) {
            return {
              retypepassword: t("The two passwords doesn't match!"),
            };
          }
          return {};
        }}
        onChange={(value) => {
          console.log("On change", value);
        }}
        isInitialValid={false}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true);
          const password = values.password.trim();
          callAPI(`/api/webshop/reset-password/` + code, "POST", {
            password,
          })
            .then((ret) => {
              if (ret.error) {
                setServerError(ret.error);
              } else {
                // FIXME: Dialog or something? Typo is from original translation
                alert(t("The password was succesfully updated."));
                history.push(routes.frontpage.path);
              }
            })
            .catch((err) => {
              console.log("server Error", err);
              setServerError(t("Error setting new password"));
            })
            .finally(() => {
              setSubmitting(false);
            });
        }}
      >
        {({ submitForm, isValid, isSubmitting }) => {
          return (
            <Form className={classes.form}>
              <Field
                component={FormikPasswordField}
                label={t("New password")}
                name="password"
                variant="outlined"
                type="password"
                parse={(value) => value.replace(" ", "")}
                fullWidth
                autoFocus
              />
              <Field
                component={FormikPasswordField}
                label={t("Retype password")}
                name="retypepassword"
                variant="outlined"
                type="password"
                fullWidth
              />

              <p>
                <FormHelperText error={!!serverError}>
                  {serverError}
                </FormHelperText>
              </p>

              <BoxActions>
                <LoadingButton
                  variant="primary"
                  isLoading={isSubmitting}
                  onClick={submitForm}
                  disabled={!isValid}
                  fullWidth
                >
                  <Trans>Reset password</Trans>
                </LoadingButton>
              </BoxActions>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default ResetPassword;
